import { tget, tpost } from "../../utils/Utils/Utils";

export function actionActivityFetchAll() {
  return (dispatch) =>
    tget('/api/v3/torga/activity').then((result) => {
      dispatch({ type: 'FETCH_ACTIVITY_COMPLETE', payload: result });
    });
}

export function actionActivityUpdate(id, field, value, callback = null) {
  return (dispatch) =>
    tpost(`/api/v3/torga/activity/${id}/${field}`, {
      [field]: value,
    }).then((result) => {
      dispatch({
        type: 'ACTIVITY_PERSIST_COMPLETED',
        payload: [result],
      });
      callback && callback(result);
    });
}

export function actionActivityCreate(parentID, name) {
  return (dispatch) =>
    tpost(`/api/v3/torga/activity`, {
      name: name,
      parentID: parentID,
      next_review: new Date().getTime(),
    }).then((resp) => {
      dispatch({
        type: 'ACTIVITY_ADD_COMPLETE',
        payload: [resp],
      });
    });
}

export function actionActivityAddGoal(activity_id, name) {
  return (dispatch) =>
    tpost(`/api/v3/torga/goal`, { name }).then((goal) => {
      dispatch({
        type: 'GOAL_CREATE_COMPLETE',
        payload: [goal],
      });
      return tpost('/api/v3/torga/activitygoal', {
        activity_id,
        goal_id: goal.id,
        deleted: false,
      });
    }).then((relation) => {
      dispatch({
        type: 'ACTIVITYGOAL_UPDATE_COMPLETE',
        payload: [relation],
      });
    });
}

export function actionActivityGoalFetchAll() {
  return (dispatch) =>
    tget('/api/v3/torga/activitygoal').then((result) => {
      dispatch({ type: 'ACTIVITYGOAL_FETCH_ALL_COMPLETE', payload: result });
    });
}